export default {
    APP_VERSION_FETCH_DATA: 'APP_VERSION_FETCH_DATA',
    APP_VERSION_OPEN_TAB: 'APP_VERSION_OPEN_TAB',
    APP_VERSION_CLOSE_TAB: 'APP_VERSION_CLOSE_TAB',
    APP_VERSION_OPEN_ALL_TABS: 'APP_VERSION_OPEN_ALL_TABS',
    APP_VERSION_CLOSE_ALL_TABS: 'APP_VERSION_CLOSE_ALL_TABS',
    APP_VERSION_START_SPINNER: 'APP_VERSION_START_SPINNER',
    APP_VERSION_STOP_SPINNER: 'APP_VERSION_STOP_SPINNER',
};
